import { render } from "./AdminPanelHeader.vue?vue&type=template&id=1526d31c&scoped=true"
import script from "./AdminPanelHeader.vue?vue&type=script&lang=js"
export * from "./AdminPanelHeader.vue?vue&type=script&lang=js"

import "./AdminPanelHeader.vue?vue&type=style&index=0&id=1526d31c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1526d31c"]])

export default __exports__